import { Box, Button, Dialog, DialogActions, DialogContent } from '@mui/material';
import { BodyText } from '@/components/BodyText';
import { TitleText } from '@/components/TitleText';

interface ConfirmDialogProperties {
  open: boolean;
  mode: 'resolve' | 'upload' | 'switch';
  dependencyName: string;
  targetName: string;
  currentResolvedName?: string;
  onConfirm: () => void;
  onCancel: () => void;
  onBack?: () => void;
}

const config = {
  resolve: { targetLabel: 'Resolve with' },
  upload: { targetLabel: 'Selected file' },
  switch: { targetLabel: 'Switch to' },
};

export const ConfirmDialog = ({
  open,
  mode,
  dependencyName,
  targetName,
  currentResolvedName,
  onConfirm,
  onCancel,
  onBack,
}: ConfirmDialogProperties) => {
  const { targetLabel } = config[mode];

  return (
    <Dialog
      fullWidth
      open={open}
      onClose={onCancel}
      maxWidth='sm'
      slotProps={{ paper: { sx: { borderRadius: '12px' } } }}
    >
      <TitleText sx={{ padding: '24px 24px 0 24px' }}>Resolve Dependency</TitleText>
      <DialogContent sx={{ padding: '16px 24px 16px 24px' }}>
        <BodyText color='text.primary' sx={{ display: 'block', mb: 1 }}>
          {currentResolvedName ? 'Dependency' : 'Missing dependency'}: <strong>{dependencyName}</strong>
        </BodyText>
        {currentResolvedName && (
          <BodyText color='text.primary' sx={{ display: 'block', mb: 1 }}>
            Currently resolved with: <strong>{currentResolvedName}</strong>
          </BodyText>
        )}
        <BodyText color='text.primary' sx={{ display: 'block' }}>
          {targetLabel}: <strong>{targetName}</strong>
        </BodyText>
      </DialogContent>
      <DialogActions sx={{ padding: '0 24px 24px 24px', ...(onBack ? { justifyContent: 'space-between' } : {}) }}>
        {onBack && (
          <Button onClick={onBack} sx={{ textTransform: 'none', borderRadius: '12px', padding: '12px 16px' }}>
            <BodyText color='text.primary'>Back</BodyText>
          </Button>
        )}
        <Box>
          <Button onClick={onCancel} sx={{ textTransform: 'none', borderRadius: '12px', padding: '12px 16px' }}>
            <BodyText color='text.primary'>Cancel</BodyText>
          </Button>
          <Button
            variant='contained'
            onClick={onConfirm}
            sx={{ textTransform: 'none', borderRadius: '12px', padding: '8px 16px' }}
          >
            Resolve
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};
